import React, { useState, useEffect, useRef } from 'react';
import s from './SplashScreen.module.css';
import logo from '../images/לוגו שובל רוימי 1.webp';

// Same images as HeroSplit
import i1 from '../images/תמונות פתיחה שובל 2.webp';
import i2 from '../images/תמונות פתיחה שובל 4.webp';
import i3 from '../images/בית של טבע וחומר 3.webp';
import i4 from '../images/קרווילות צימרים 2.webp';

const HERO_SRCS = [i1, i2, i3, i4];
const TOTAL = HERO_SRCS.length;

export default function SplashScreen({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [exiting, setExiting] = useState(false);
  const loaded = useRef(0);
  const done = useRef(false);
  const minReady = useRef(false);

  useEffect(() => {
    // Minimum 2s so logo animation plays
    const minTimer = setTimeout(() => {
      minReady.current = true;
      tryFinish();
    }, 2000);

    // Preload each hero image
    HERO_SRCS.forEach((src) => {
      const img = new Image();
      const handle = () => {
        loaded.current = Math.min(loaded.current + 1, TOTAL);
        setProgress(Math.round((loaded.current / TOTAL) * 100));
        if (loaded.current >= TOTAL) tryFinish();
      };
      img.onload = handle;
      img.onerror = handle;
      img.src = src;
    });

    return () => clearTimeout(minTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function tryFinish() {
    if (done.current) return;
    if (minReady.current && loaded.current >= TOTAL) {
      done.current = true;
      setProgress(100);
      setTimeout(() => {
        setExiting(true);
        setTimeout(() => onDone(), 800);
      }, 500);
    }
  }

  return (
    <div className={`${s.splash} ${exiting ? s.splashExit : ''}`}>
      <div className={s.grain} />

      {/* Logo */}
      <div className={s.logoWrap}>
        <img src={logo} alt="SRA" className={s.logo} />
      </div>

      {/* Progress */}
      <div className={s.loadingArea}>
        <span className={s.progressNum}>{progress}%</span>
        <div className={s.progressWrap}>
          <div className={s.progressBar} style={{ width: `${progress}%` }} />
        </div>
        <p className={s.loadingText}>טוענים את החוויה..</p>
      </div>

      {/* Corners */}
      <span className={`${s.corner} ${s.cornerTL}`} />
      <span className={`${s.corner} ${s.cornerBR}`} />
    </div>
  );
}
